import request from "./request";

// 删除自定义列
export const deleteDefineColumn = (data) => request("/totalReport/delCustomColumn", data, "GET");

// 查询自定义列
export const searchDefineColumn = (data) => request("/totalReport/queryCustomColumn", data, "GET");

// 保存自定义列
export const saveDefineColumn = (data) => request("/totalReport/saveCustomColumn", data, "POST_JSON");

// 修改自定义列
export const modifyDefineColumn = (data) => request("/totalReport/updateCustomColumn", data, "POST_JSON");

